module.exports = __webpack_public_path__ + "static/img/4.cf25119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/cpxh/4.jpg
// module id = FwMH
// module chunks = 0